export default __webpack_public_path__ + "static/media/T42.8619f369.JPG";